export const removeNonIntegersFromString = (str: string | null): string => {
  if (!str) return "";
  return str.replace(/\D/g, "");
};

// Qualquer caractere que não seja letra, número ou espaço é considerado especial
export const SPECIAL_CHARACTERS_REGEX = /[^A-Za-z\d\s]/;

// Regra única de senha: 8+ caracteres, sem espaços, com minúscula, maiúscula,
// número e ao menos um caractere especial (qualquer símbolo).
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d\s])\S{8,}$/;

export const checkIfHasSpecialCharacters = (str: string): boolean => {
  return SPECIAL_CHARACTERS_REGEX.test(str);
};

export const checkIfHasUpperCase = (str: string): boolean => {
  return !!str.match(/[A-Z]/);
};
export const checkIfHasLoweCase = (str: string): boolean => {
  return !!str.match(/[a-z]/);
};
export const checkIfHasNumbers = (str: string): boolean => {
  return /\d/.test(str);
};

export const checkIfIsAllSameDigit = (str: string): boolean => {
  let allSameDigit = true;
  for (let i = 1; i < str.length; i++) {
    if (str[i] !== str[0]) {
      allSameDigit = false;
      break;
    }
  }
  return allSameDigit;
};
export const emptyStringToNull = <T>(value: T): T | null => {
  if (typeof value === "string" && value.trim() === "") {
    return null;
  }
  return value;
};

export const normalizeEmptyStrings = <T extends { [key: string]: unknown }>(data: T): T => {
  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [key, emptyStringToNull(value)])
  ) as T;
};
